/**
 * Voice Characters Service
 * API client for voice character management and preview audio
 * Uses Inworld TTS provider
 */

import type { VoiceCharactersResponse } from '../types/voice-characters';

import { API_BASE_URL } from '../config';

class VoiceCharactersService {
  /**
   * Get all voice characters grouped by gender
   * @param provider - TTS provider, defaults to 'inworld'
   */
  async getAllCharacters(provider = 'inworld'): Promise<VoiceCharactersResponse> {
    try {
      const params = new URLSearchParams();
      params.set('provider', provider);
      const response = await fetch(`${API_BASE_URL}/v1/voice-characters?${params.toString()}`);
      const data = await response.json();
      return data;
    } catch (error: any) {
      console.error('Failed to fetch voice characters:', error);
      return {
        success: false,
        error: error.message || 'Failed to fetch voice characters',
      };
    }
  }

}

const voiceCharactersService = new VoiceCharactersService();
export default voiceCharactersService;
